export default __webpack_public_path__ + "static/media/smoking-yellow.8dea3341.svg";